/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClaimEvidenceControllerFindAllQueryResponse, ClaimEvidenceControllerFindAllQueryParams, ClaimEvidenceControllerFindAll401, ClaimEvidenceControllerFindAll403 } from "../../models/checklistsController/ClaimEvidenceControllerFindAll";

function getClaimEvidenceControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-application-claim-evidence` as const }  
  return res
}

/**
 * @summary List checklist claim evidence
 * {@link /api/v1/checklist-application-claim-evidence}
 */
export async function claimEvidenceControllerFindAll(params?: ClaimEvidenceControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ClaimEvidenceControllerFindAllQueryResponse, ResponseErrorConfig<ClaimEvidenceControllerFindAll401 | ClaimEvidenceControllerFindAll403>, unknown>({ method : "GET", url : getClaimEvidenceControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}